module.exports = __webpack_public_path__ + "static/media/GeneralClass.103bbb23.jpg";